import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/captain'),
      redirect: to => ({
        name: 'wizard_settings_index',
        params: { accountId: to.params.accountId },
      }),
      meta: {
        permissions: ['administrator'],
        featureFlag: FEATURE_FLAGS.WIZARD,
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/wizard'),
      meta: {
        permissions: ['administrator'],
        featureFlag: FEATURE_FLAGS.WIZARD,
      },
      component: () => import('../SettingsWrapper.vue'),
      props: {
        headerTitle: 'WIZARD_SETTINGS.TITLE',
        icon: 'i-woot-wizard',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'wizard_settings_index',
          component: () => import('./Index.vue'),
          meta: {
            permissions: ['administrator'],
            featureFlag: FEATURE_FLAGS.WIZARD,
          },
        },
      ],
    },
  ],
};
